import { render, staticRenderFns } from "./SettingsCleaner.vue?vue&type=template&id=625050fc"
import script from "./SettingsCleaner.vue?vue&type=script&lang=js"
export * from "./SettingsCleaner.vue?vue&type=script&lang=js"
import style0 from "./SettingsCleaner.vue?vue&type=style&index=0&id=625050fc&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports